export default __webpack_public_path__ + "static/media/1038_1040_new.f9a71ddf.jpg";